<template>
  <div class="forget">
    <van-sticky>
      <div class="header">
        <van-icon name="arrow-left" color="#fff" class="vanIcon" @click="returnIndex" />
        <span class="addInfo">修改密码</span>
      </div>
    </van-sticky>
    <div class="forget_content">
      <div class="user">
        <img src="../../assets/img/user.png" alt="" class="userImg" />
        <input type="text" class="input" placeholder="请输入用户名" v-model="form.username" />
      </div>
      <div class="user" style="margin-top: 1.2rem">
        <img src="../../assets/img/password.png" alt="" class="userImg" />
        <input type="text" class="input" placeholder="请输入手机号" v-model="form.moblie" />
      </div>
      <div class="user" style="margin-top: 1.2rem">
        <img src="../../assets/img/newPsw.png" alt="" class="userImg" />
        <input type="text" class="input" placeholder="输入数字与字母组合6-20位新密码" v-model="form.newPsw" />
      </div>
      <div class="reset_psw" style="margin-top: 1.2rem;">
        <div class="user">
          <img src="../../assets/img/SMS-verification.png" alt="" class="userImg" />
          <input type="text" class="input " placeholder="输入短信验证码" v-model="form.verification" />
        </div>
        <span class="verification" v-show="!show" @click="getVerification">获取验证码</span>
        <span class="countdown" v-show="show"><span>{{countdown}}</span><span>秒后重试</span></span>
      </div>
    </div>
    <div class="forgetButton" @click="onLogin">确定</div>

  </div>
</template>
<script>
  import {
    sendSms,
    updateAccount
  } from '@/axios/api'
  export default {
    data() {
      return {
        form: {},
        countdown: '',
        show: false,
        timer: null
      }
    },
    created() {},
    methods: {
      returnIndex() {
        this.$router.push('/')
      },
      onLogin() {
        if (this.form.moblie == "" || !this.form.moblie) {
          this.$toast({
            message: '手机号码不能为空',
            position: 'top',
          });
          return
        } else if (this.form.newPsw == "" || !this.form.newPsw) {
          this.$toast({
            message: '请输入新密码',
            position: 'top',
          });
          return
        } else if (this.form.verification == "" || !this.form.verification) {
          this.$toast({
            message: '请输入验证码',
            position: 'top',
          });
          return
        } else {
          let data = {
            userName: this.form.username,
            smsCode: this.form.verification,
            password: this.$md5(this.form.newPsw),
            mobile: this.form.moblie
          }
          updateAccount(data).then((res) => {
            if (res.result == true) {
              console.log(res)
              this.$toast.success('密码修改成功');
              this.$router.push('/login')
            } else {
              console.log(res.errMsg)
              // this.$toast.fail(res.errMsg);
            }

          }).catch((err) => {
            this.$toast.fail(err);
            console.log(err)

          })
        }

      },
      getVerification() {
        if (this.form.moblie == "" || !this.form.moblie) {
          this.$toast({
            message: '手机号码不能为空',
            position: 'top',
          });
          return
        } else if (this.form.newPsw == "" || !this.form.newPsw) {
          this.$toast({
            message: '请输入新密码',
            position: 'top',
          });
          return
        } else {
          var Reg = /^[1][34578][0-9]{9}$/;
          // 正则验证
          if (Reg.test(this.form.moblie)) {
            this.$toast('验证码发送成功')
            if (!this.timer) {
              const TIME_COUNT = 60;
              this.countdown = TIME_COUNT;
              this.show = true
              this.timer = setInterval(() => {
                if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
                  this.countdown--;
                } else {
                  this.show = false
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000)
            }
            let data = {
              userName: this.form.username,
              mobile: this.form.moblie
            }
            sendSms(data).then((res) => {
              if (res.result == true) {
                console.log(res)
                this.$toast.success(res.data);
              } else {
                this.$toast.fail(res.errMsg);
              }

            }).catch((err) => {
              this.$toast.fail(err);
              console.log(err)

            })
          } else {
            this.$toast('手机号格式不正确')
          }
        }

      }
    }
  }

</script>
<style scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .forget_content {
    width: 86%;
    margin: 1rem auto;
  }

  .input {
    height: 2.5rem;
    border: none;
    background: #fff;
    display: block;
    outline: none;
    -webkit-appearance: button;
    font-size: 0.875rem;
    margin-left: 1rem;
    width: 100%;
  }

  .reset_psw {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .forgetButton {
    width: 86%;
    margin: 0 auto;
    height: 2.875rem;
    background: linear-gradient(122deg, #17bcc5 0%, #0164a8 100%);
    margin: 0 auto;
    border-radius: 5rem;
    text-align: center;
    line-height: 3rem;
    font-size: 0.875rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-top: 2rem;
  }

  .verification {
    font-size: 0.75rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0364a8;
    margin-right: 3%;
  }

  .userImg {
    width: 1.2rem;
  }

  .user {
    display: flex;
    align-items: center;
  }

  .countdown {
    font-size: 0.875rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #108ee9;
  }

  .vanIcon {
    position: absolute;
    left: 1.3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/forget.vue